import { View, useWindowDimensions, FlatList, ImageBackground } from 'react-native-web';
import {CardHome} from '../../element/Card';
import { HomeList } from '../../List/HomeList';




const Home = () => {
    const windows=useWindowDimensions();
    
  return (
  
    
 
  
    <View style={{height:windows.height, width:windows.width, }}>
     <FlatList data={HomeList}
            keyExtractor={(item)=>item.id}
            showsVerticalScrollIndicator={false}
            pagingEnabled={true}
            
            renderItem={({ item }) => (
                <View style={{width:windows.width ,height:windows.height, alignItems:'center'}}>
                  <CardHome image={item.image} body={item.body} title={item.title} />
                </View>)}/>
     </View>


 );}

export default Home

   /*   */